module.exports = __webpack_public_path__ + "static/img/cabinet24_21.5c734419.gif";